import { Link, useLocation } from "react-router-dom";
import {
  currentUserDisplayName,
  currentUserEmail,
  currentUserSub,
  decodeJwtPayload,
  loadTokens,
  performLogout,
} from "../../auth";
import { maskUserSub } from "@vida/surf-core";
import { useSurfCreditsBalance } from "../../hooks/useSurfCreditsBalance";
import { useSurfActivityFeed } from "../../hooks/useSurfActivityFeed";
import { SurfActivityPanel } from "./SurfActivityPanel";

export function SurfSidebar() {
  const location = useLocation();
  const path = location.pathname;
  const { balanceLabel, loading: creditsLoading, unavailable: creditsUnavailable } =
    useSurfCreditsBalance();
  const activity = useSurfActivityFeed(true);

  const email = currentUserEmail();
  const name = currentUserDisplayName();
  const tokens = loadTokens();
  const issuer = tokens ? (decodeJwtPayload(tokens.id_token)?.iss as string | undefined) : undefined;

  return (
    <aside className="surf-sidebar" aria-label="Navigazione Surf">
      <header className="surf-brand">
        <span className="surf-brand-mark" aria-hidden />
        <span className="surf-brand-title">Surf</span>
      </header>

      <nav className="surf-nav" aria-label="Principale">
        <Link className={`surf-nav-link${path === "/" ? " active" : ""}`} to="/">
          Libreria
        </Link>
        <Link className={`surf-nav-link${path === "/account" ? " active" : ""}`} to="/account">
          Account
        </Link>
      </nav>

      <section className="surf-sidebar-user" aria-label="Utente">
        <p className="surf-sidebar-user-name">{name}</p>
        {email && <p className="muted surf-sidebar-user-email">{email}</p>}
        <p className="surf-sidebar-credits">
          Crediti: <strong>{creditsLoading ? "…" : balanceLabel}</strong>
        </p>
        {creditsUnavailable && (
          <p className="muted surf-sidebar-credits-error" title="Richiede deploy admin-api con audience web_surf">
            Crediti non disponibili
          </p>
        )}
        <p className="muted surf-sidebar-meta" title={currentUserSub()}>
          sub {maskUserSub(currentUserSub())}
        </p>
        {issuer && (
          <p className="muted surf-sidebar-meta" title={issuer}>
            iss {issuer.replace(/^https?:\/\//, "").slice(0, 28)}
            {issuer.length > 30 ? "…" : ""}
          </p>
        )}
      </section>

      <SurfActivityPanel
        jobs={activity.jobs}
        loading={activity.loading}
        error={activity.error}
        onRefresh={() => void activity.refresh()}
      />

      <div className="surf-sidebar-footer">
        <button type="button" className="surf-btn surf-btn--sidebar" onClick={() => performLogout()}>
          Esci
        </button>
      </div>
    </aside>
  );
}
